const guidePathMap = {
  'WEB (JS)': '/map-feature-guide',
  '장소/주소 검색': '/search-feature-guide#web-search-place',
  지오코딩: '/search-feature-guide#web-search-geocoding',
  '공간 검색': '/search-feature-guide#web-search-space',
  w3w: '/search-feature-guide#web-search-w3w',
  탐색: '/route-feature-guide#web-route-explore',
  최적화: '/route-feature-guide#web-route-optimize',
  복원: '/route-feature-guide#web-route-restore',
  매트릭스: '/route-feature-guide#web-route-matrix',
};

const getFeatureGuidePath = (title) => {
  return guidePathMap[title];
};

module.exports = {
  guidePathMap,
  getFeatureGuidePath,
};
